/**
 * configureHelmet
 *
 * Global react-helmet configuration. Imported for its side effect, before the
 * app renders.
 */
import { Helmet } from 'react-helmet';

// react-helmet commits its tags inside a requestAnimationFrame (its `defer`
// prop, on by default). The callback is scheduled once, and a frame that never
// comes — tab loaded in the background, hidden or throttled renderer — leaves
// the document with no <title>, no description, no canonical and no hreflang
// at all, for good, while the page itself renders perfectly: nothing in React
// depends on that frame. Committing synchronously is the only way the <head>
// is guaranteed to be written.
// It has to be the default rather than defer={false} on a <Helmet>: the
// innermost one wins this prop, and every page mounts its own below App's.
Helmet.defaultProps.defer = false;
